module.exports = __webpack_public_path__ + "static/media/audience-crowd-holi.1b7b09ea.png";